"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RAMP_SUPPORTED_CRYPTOS = exports.MERCURYO_UNSUPPORTED_STATES = exports.MERCURYO_UNSUPPORTED_COUNTRIES = exports.CEX_UNSUPPORTED_STATES = exports.CEX_UNSUPPORTED_COUNTRIES = exports.SIMPLEX_UNSUPPORTED_STATES = exports.SIMPLEX_UNSUPPORTED_COUNTRIES = exports.CEX_API_COUNTRIES = exports.RAMP_API_KEY = exports.CEX_PLACEMENT_ID = exports.MOONPAY_IP = void 0;
exports.MOONPAY_IP = `https://api.moonpay.com/v3/ip_address/?apiKey=pk_live_k6WSd0AaHVEXPV4WlBBrsvRMrAhRH`;
exports.CEX_PLACEMENT_ID = "92e9c25a-327a-4367-b12e-1deebcca0776";
exports.RAMP_API_KEY = "6gnxz2tsz7yabpcfxupqyqzzkvov2h9n6h8ba68f";
exports.CEX_API_COUNTRIES = `https://api.cexdirect.com/api/v1/payments/countries?placementId=${exports.CEX_PLACEMENT_ID}`;
exports.SIMPLEX_UNSUPPORTED_COUNTRIES = [
    "BS",
    "BW",
    "CD",
    "CG",
    "KH",
    "KP",
    "ET",
    "GH",
    "IR",
    "PK",
    "PA",
    "LK",
    "SY",
    "TT",
    "TN",
    "YE", // Yemen
];
exports.SIMPLEX_UNSUPPORTED_STATES = [
    "AK",
    "HI",
    "WA",
    "NM",
    "VT",
    "FL",
    "OR",
    "AL", // Alabama
    // NY (supported for BTC)
];
exports.CEX_UNSUPPORTED_COUNTRIES = [
    "AF",
    "BA",
    "BD",
    "BO",
    "BI",
    "CD",
    "CF",
    "CU",
    "DZ",
    "EC",
    "ET",
    "IQ",
    "IR",
    "IS",
    "KH",
    "KP",
    "LA",
    "LB",
    "LY",
    "MA",
    "NP",
    "PK",
    "SO",
    "SS",
    "SD",
    "SY",
    "UG",
    "VU",
    "YE",
    "ZW", // Zimbabwe
];
exports.CEX_UNSUPPORTED_STATES = [
    "NY",
    "TX", // Texas (pending)
];
exports.MERCURYO_UNSUPPORTED_COUNTRIES = [
    "BD",
    "BO",
    "BI",
    "CF",
    "CN",
    "CO",
    "CU",
    "CD",
    "EC",
    "IQ",
    "IR",
    "KG",
    "LB",
    "LY",
    "ML",
    "MA",
    "NP",
    "NI",
    "KP",
    "PK",
    "SA",
    "SO",
    "SD",
    "SS",
    "SY",
    "VN",
    "VE",
    "YE",
    "ZW", // Zimbabwe
];
exports.MERCURYO_UNSUPPORTED_STATES = [
    "HI",
    "NY", // New York
];
exports.RAMP_SUPPORTED_CRYPTOS = [
    "ETH",
    "BCH",
    "BTC",
    "LTC",
    "DOT",
    "DOGE",
    "XRP",
    "AVAX",
];
//# sourceMappingURL=constants.js.map